/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Grid } from '@coursera/cds-core';

import ConsumerSearchBarGridItem from 'bundles/composable-page-header-consumer/components/ConsumerSearchBarGridItem';
import ExploreMegaMenuGridItem from 'bundles/composable-page-header-consumer/components/ExploreMegaMenuGridItem';
import DefaultConsumerPageHeaderProvider from 'bundles/composable-page-header-consumer/providers/DefaultConsumerPageHeaderProvider';
import GlobalPageHeaderContainer from 'bundles/composable-page-header/components/GlobalPageHeaderContainer';
import MainNavigationWrapper from 'bundles/composable-page-header/components/MainNavigationWrapper';
import CourseraHomeLogo from 'bundles/composable-page-header/components/grid-items/home-logo/CourseraHomeLogo';
import HomeLogoGridItemModule from 'bundles/composable-page-header/components/grid-items/home-logo/HomeLogoGridItemModule';
import MobileSearchBarGridItem from 'bundles/composable-page-header/components/grid-items/mobile/MobileSearchBarGridItem';
import DefaultMetaNavigation from 'bundles/composable-page-header/components/meta-nav/DefaultMetaNavigation';
import { DEFAULT_META_NAV_HEIGHT } from 'bundles/composable-page-header/constants';
import GlobalPageHeaderStateProvider from 'bundles/composable-page-header/providers/GlobalPageHeaderStateProvider';

const styles = {
  leftSide: css`
    width: auto;
  `,
  middleSide: css`
    flex-shrink: 1;
    flex-grow: 1;
    flex-basis: 0%;
    padding: 10px 16px;
    width: 100%;
  `,
  rightSide: css`
    width: auto;
  `,
};

/**
 * Desktop navigation for deletion confirmation - logo, explore, search bar, no right nav
 */
const DeletionConfirmationDesktopMainNav = () => {
  return (
    <MainNavigationWrapper>
      <Grid item container alignItems="center" spacing={16} css={styles.leftSide}>
        <Grid item>
          <HomeLogoGridItemModule href="/" logos={[<CourseraHomeLogo key="1" />]} />
        </Grid>
        <Grid item>
          <ExploreMegaMenuGridItem />
        </Grid>
      </Grid>
      <Grid item css={styles.middleSide}>
        <ConsumerSearchBarGridItem />
      </Grid>
      <Grid item container alignItems="center" justifyContent="flex-end" wrap="nowrap" css={styles.rightSide}>
        {/* Empty right side - no user dropdown, notifications, etc. */}
      </Grid>
    </MainNavigationWrapper>
  );
};

/**
 * Mobile navigation for deletion confirmation - just logo and search, no account menu
 */
const DeletionConfirmationMobileMainNav = () => {
  return (
    <MainNavigationWrapper>
      <Grid item xs={8} sm={6} container alignItems="center">
        <HomeLogoGridItemModule href="/" logos={[<CourseraHomeLogo key="1" />]} />
      </Grid>
      <Grid item container xs={4} sm={6} alignItems="center" justifyContent="flex-end">
        <MobileSearchBarGridItem />
      </Grid>
    </MainNavigationWrapper>
  );
};

/**
 * Composable page header for deletion confirmation page.
 * Shows: Meta navigation, Logo, Explore button, Search bar
 * Hides: User dropdown, notifications, shopping cart, hamburger menu, etc.
 */
const DeletionConfirmationHeader = () => {
  return (
    <GlobalPageHeaderContainer
      desktopMainNav={<DeletionConfirmationDesktopMainNav />}
      mobileMainNav={<DeletionConfirmationMobileMainNav />}
      metaNav={<DefaultMetaNavigation />}
      scrollMovementOffset={{
        desktop: DEFAULT_META_NAV_HEIGHT,
        mobile: 0,
      }}
      banners={[]}
    />
  );
};

/**
 * Header component specifically for the deletion confirmation page with provider wrapper.
 * Shows: Meta navigation, Logo, Explore button, Search bar
 * Hides: User dropdown, notifications, shopping cart, hamburger menu, etc.
 */
const AccountDeletionConfirmationHeaderWithProvider = () => {
  return (
    <GlobalPageHeaderStateProvider additionalDefaultPageHeaderHeight={DEFAULT_META_NAV_HEIGHT}>
      <DefaultConsumerPageHeaderProvider>
        <DeletionConfirmationHeader />
      </DefaultConsumerPageHeaderProvider>
    </GlobalPageHeaderStateProvider>
  );
};

export default AccountDeletionConfirmationHeaderWithProvider;
